import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ListtemplatePage } from './listtemplate.page';

const routes: Routes = [
  {
    path: '',
    component: ListtemplatePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ListtemplatePageRoutingModule {}
